import { ConstraintMinMaxRigsPerAreaDetailBase } from './base/constraint-min-max-rigs-per-area-detail-base';

export class ConstraintMinMaxRigsPerAreaDetail extends ConstraintMinMaxRigsPerAreaDetailBase { }